export const payorFieldId = "payorFieldId";

export const getPayorOptionId = (index: number) =>
  `${payorFieldId}-option-${index + 1}`;

export const getPayorsListboxId = () => `${payorFieldId}-listbox`;
